import { ESortChainsType } from '@ankr.com/chains-list';
import { useState } from 'react';

import { useAuth } from 'modules/auth/hooks/useAuth';
import { usePublicChainsInfo } from 'hooks/usePublicChainsInfo';
import { useSearch } from 'modules/common/components/Search/hooks/useSearch';

export const usePublicChainsList = () => {
  const { isLoggingIn } = useAuth();

  const { chains, isLoading: publicChainsLoading } = usePublicChainsInfo();

  const [sortType, setSortType] = useState(ESortChainsType.Trending);

  const [searchContent, setSearchContent] = useSearch();

  return {
    chains,
    loading: isLoggingIn || publicChainsLoading,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
  };
};
